﻿/* 
Object:         User Scheduler
Description:    Logic and events for the module UserScheduler
Used in:        UserScheduler
*/

window.userscheduler = function () {

    // temp data scheduler 
    var tempData = null;

    // current state of the mouse button
    var mouseDown = 0;

    // captured by change event kendo scheduler (start selection)
    var selectionChangeStart = null;

    // captured by change event kendo scheduler (end selection)
    var selectionChangeEnd = null;

    /**
    * Hide piket options (function, groups)
    */
    function showHidePiketOptions() {
        var selectedTypeOfEdit = parseInt($("#TypeOfEdit").data("kendoDropDownList").value());

        // Hide values that are not editable.
        // we should not have to do this because in the model we already declared with a tag
        // SEE: https://docs.telerik.com/aspnet-core/html-helpers/layout/form/hidden-fields
        //main.setHideKendoUIFormItem('UserId', false);
        //main.setHideKendoUIFormItem('MyUserId', false);

        main.setHideDivBootstrap('divFunction', false);
        main.setHideDivBootstrap('divAssignedGroups', false);

        if (selectedTypeOfEdit === 3) {
            main.setHideDivBootstrap('divFunction', true);
            main.setHideDivBootstrap('divAssignedGroups', true);
        }
    }

    /**
    * Hide piket options (function, groups)
    */
    function hideHiddenFields() {

        // Hide values that are not editable.
        // we should not have to do this because in the model we already declared with a tag
        // SEE: https://docs.telerik.com/aspnet-core/html-helpers/layout/form/hidden-fields
        //main.setHideKendoUIFormItem('UserId', false);
        //main.setHideKendoUIFormItem('MyUserId', false);
    }

    /**
    * Get the settings filled in the generated form. 
    * @param {any} amountOfDays
    */
    function GetShiftWorkDaySettings(amountOfDays) {
        var arrFromTo = [];

        // Loop through input fields for the repeated moments.
        for (var row = 1; row <= amountOfDays; row++) {

            for (var numMoment = 1; numMoment <= 3; numMoment++) {
                var valueResult = ($("#" + row + "_" + numMoment + "_From").data("kendoTimePicker") != undefined &&
                    $("#" + row + "_" + numMoment + "_From").data("kendoTimePicker").value() != null &&
                    $("#" + row + "_" + numMoment + "_To").data("kendoTimePicker") != undefined &&
                    $("#" + row + "_" + numMoment + "_To").data("kendoTimePicker").value() != null);

                if (valueResult) {                    
                    var obj = {
                        Day: row,
                        MomentNbr: numMoment,
                        TimeFrom: ($("#" + row + "_" + numMoment + "_From").data("kendoTimePicker").value().getHours() * 60) + $("#" + row + "_" + numMoment + "_From").data("kendoTimePicker").value().getMinutes(),
                        TimeTo: ($("#" + row + "_" + numMoment + "_To").data("kendoTimePicker").value().getHours() * 60) + $("#" + row + "_" + numMoment + "_To").data("kendoTimePicker").value().getMinutes()
                    };

                    arrFromTo.push(obj);
                }
            }
        }

        return arrFromTo;
    }

    /**
    * Post request to the backend to fill a certain day with a value (boolean)
    * @param {boolean} available
    */
    function _DialogFullDayAvailable(available) {
        // Post Data
        $.ajax({
            type: "POST",
            url: appsettings.getUrl("UserScheduler/SetFullDay"),
            data: {
                UserId: parseInt($("#SelectedUserId").val()),
                SelectedDate: $("#SelectedDate").val(),
                Available: available
            },
            success: function (responseData) {
                var popupNotification = $("#popupNotification").kendoNotification().data("kendoNotification");
                
                if (responseData.Succesfully) {
                    popupNotification.show(responseData.Message, "info");
                    $("#scheduler").data("kendoScheduler").dataSource.read();   // refresh
                } else {
                    popupNotification.show(responseData.Message, "error");
                }
            }
        });
    }

    /**
    * Init form shift for the button. Gets the information already filled (certain settings).
    * @param {any} event
    */
    function onFormSubmit_FormPeriod(e) {
        // Prevent default behaviour
        e.preventDefault();

        // Post Data
        $.ajax({
            type: "POST",
            url: appsettings.getUrl(e.model.FormAction),
            data: {
                myUserId: e.model.myUserId,
                UserId: e.model.UserId,
                From: e.model.From,
                FromUTCHour: e.model.FromUTCHour,
                FromUTCMinutes: e.model.FromUTCMinutes,
                To: e.model.To,
                ToUTCHour: e.model.ToUTCHour,
                ToUTCMinutes: e.model.ToUTCMinutes,
                FromDate: e.model.FromDate,
                ToDate: e.model.ToDate,
                ForMonday: e.model.ForMonday,
                ForTuesday: e.model.ForTuesday,
                ForWednesday: e.model.ForWednesday,
                ForThursday: e.model.ForThursday,
                ForFriday: e.model.ForFriday,
                ForSaturday: e.model.ForSaturday,
                ForSunday: e.model.ForSunday,
                SelectedDays: e.model.SelectedDays,
                RepeatEveryNumberOfWeeks: parseInt(e.model.RepeatEveryNumberOfWeeks),
                TypeOfEdit: e.model.TypeOfEdit,
                SelectedFunction: e.model.SelectedFunction,
                Function: e.model.Function,
                SelectedGroups: e.model.SelectedGroups,
                GroupItemsList: e.model.GroupItemsList,
                FormAction: e.model.FormAction
            },

            success: function (responseData) {
                form.showServerResponse("formUserScheduler_FormPeriod", responseData);

                $("#PeriodScheduleWindow").data("kendoWindow").close();
                $("#scheduler").data("kendoScheduler").dataSource.read();
            }
        });
    }


    /**
    * Submit formshift (custom and not handled by the taghelper because of the dynamic generated form and values presented in the form)
    * @param {any} e
    */
    function onFormSubmit_FormShift(e) {
        // Prevent default behaviour
        e.preventDefault();

        // Post Data
        $.ajax({
            type: "POST",
            url: appsettings.getUrl("UserScheduler/SaveSettingsShifts"),
            data: {
                ShiftWorkID: e.model.ShiftWorkID,
                UserID: e.model.UserID,
                AmountOfDays: e.model.AmountOfDays,
                ShiftType: parseInt(e.model.ShiftType),
                StartDate: e.model.StartDate,
                ShiftWorkDays: GetShiftWorkDaySettings(e.model.AmountOfDays),
                SchedulerType: 1, // UserScheduler
            },
            success: function (responseData) {
                if (responseData.Succesfully) {
                    $('#ShiftWorkID').val(responseData.Id);

                    // Post Data
                    $.ajax({
                        type: "GET",
                        url: appsettings.getUrl("UserScheduler/FormShift?userId=" + parseInt($("#SelectedUserId").val())),

                        success: function (responseData) {
                            $("#PloegenScheduleWindow").html(responseData);
                        }
                    });

                    form.showServerResponse(responseData);
                } else {
                    $('#ShiftWarning').text(responseData.Message)
                }
            }
        });    
    }

    return {
        /**
        * Init (set all the click events for the buttons and close all windows made initial by the taghelpers)
        */
        initialize: function () {

            //
            $("#DialogFullDayNotAvailable").data("kendoDialog").close();

            // close just created window's
            $("#PeriodScheduleWindow").data("kendoWindow").close();
            $("#PloegenScheduleWindow").data("kendoWindow").close();

            // button click window
            $("#showPeriodSchedulerDialogBtn").click(function (e) {

                // open the window centered
                $("#PeriodScheduleWindow").data("kendoWindow").center().open();

                // init show hide piket options (function, groups)
                showHidePiketOptions();
            });

            // button click window
            $("#showPloegenSchedulerDialogBtn").click(function (e) {

                // open the window centered
                $("#PloegenScheduleWindow").data("kendoWindow").center().open();

                // init show hide piket options (function, groups)
                hideHiddenFields();

            });

            // button click window
            $("#thisWeekNotAvailableDialogBtn").click(function (e) {

                // open the dialog centered
                $("#DialogFullWeekNotAvailable").data("kendoDialog").open()

            });

            // button click sync pager
            $("#pagerSyncDialogBtn").click(function (e) {
                $.post({
                    type: "POST",
                    url: appsettings.getUrl("UserScheduler/SyncPager"),
                    data: {
                        selectedUserId: parseInt($("#SelectedUserId").val())
                    },
                    success: function (responseData) {
                        var popupNotification = $("#popupNotification").kendoNotification().data("kendoNotification");

                        if (responseData.Succesfully) {
                            popupNotification.show(responseData.Message, "info");
                        } else {
                            popupNotification.show(responseData.Message, "error");
                        }
                    }
                });
            });

            // event handlers for mouse button up and down
            document.body.onmousedown = function () {
                mouseDown = 1;
            }

            // event handlers for mouse button up and down
            document.body.onmouseup = function () {

                var userId = null; // userid not selected (logged in user will be used if none is given to the server)

                // user selection
                if ($("#SelectedUserId").val() != '') {
                    userId = parseInt($("#SelectedUserId").val());
                }

                // if certain selection + mousebutton was down
                if (mouseDown == 1 && selectionChangeStart != null && selectionChangeEnd != null) {

                    // create event
                    $.post({
                        type: "POST",
                        url: appsettings.getUrl("UserScheduler/SchedulerCreate"),
                        data: {
                            selectedUserId: userId,
                            UTCstart: selectionChangeStart.toUTCString(),
                            UTCend: selectionChangeEnd.toUTCString()
                        },
                        success: function (responseData) {
                            var popupNotification = $("#popupNotification").kendoNotification().data("kendoNotification");

                            $("#scheduler").data("kendoScheduler").dataSource.read();   // refresh

                            if (responseData.Succesfully) {                                
                                popupNotification.show(responseData.Message, "info");   // info
                            }
                            else {
                                popupNotification.show(responseData.Message, "error");
                            }
                        }
                    });


                    // reset vars
                    selectionChangeStart = null;
                    selectionChangeEnd = null;
                }

                mouseDown = 0;
            }

        },

        /**
        * Init form period in the window with the submit event (custom with the reason of certain logic that is executed to send to the server)
        */
        initFormPeriod: function () {
            // Form Submit ajax call
            $('#formUserScheduler_FormPeriod').submit(function (event) {
                // Prevent default
                event.preventDefault();

                // Make model to send.
                var vm = {}
                vm.preventDefault = event.preventDefault

                // CheckboxGroup
                var monday = false, tuesday = false, wednesday = false, thursday = false, friday = false, saterday = false, sunday = false;
                var data = $('#SelectedDays').data("kendoCheckBoxGroup").value();

                for (var i = 0; i < data.length; i++) {
                    switch (data[i])
                    {
                        case "1":
                            monday = true;
                            break;
                        case "2":
                            tuesday = true;
                            break;
                        case "4":
                            wednesday = true;
                            break;
                        case "8":
                            thursday = true;
                            break;
                        case "16":
                            friday = true;
                            break;
                        case "32":
                            saterday = true;
                            break;
                        case "64":
                            sunday = true;
                            break;
                    }
                }

                // Model
                vm.model = {
                    myUserId: parseInt($(event.currentTarget).find("#MyUserId").val()),
                    UserId: parseInt($(event.currentTarget).find("#UserId").val()),
                    From: $(event.currentTarget).find("#FromDate").val(),
                    FromUTCHour: $(event.currentTarget).find("#From").data("kendoTimePicker").value().getHours(),
                    FromUTCMinutes: $(event.currentTarget).find("#From").data("kendoTimePicker").value().getMinutes(),
                    To: $(event.currentTarget).find("#ToDate").val(),
                    ToUTCHour: $(event.currentTarget).find("#To").data("kendoTimePicker").value().getHours(),
                    ToUTCMinutes: $(event.currentTarget).find("#To").data("kendoTimePicker").value().getMinutes(),
                    FromDate: $(event.currentTarget).find("#FromDate").data("kendoDatePicker").value().toUTCString(),
                    ToDate: $(event.currentTarget).find("#ToDate").data("kendoDatePicker").value().toUTCString(),
                    ForMonday: monday,
                    ForTuesday: tuesday,
                    ForWednesday: wednesday,
                    ForThursday: thursday,
                    ForFriday: friday,
                    ForSaturday: saterday,
                    ForSunday: sunday,
                    SelectedDays: $(event.currentTarget).find("#SelectedDays").data("kendoCheckBoxGroup").value(),
                    RepeatEveryNumberOfWeeks: parseInt($(event.currentTarget).find("#RepeatEveryNumberOfWeeks").val()),
                    TypeOfEdit: parseInt($(event.currentTarget).find("#TypeOfEdit").val()),
                    Function: $(event.currentTarget).find("#Function").val(),
                    SelectedGroups: $(event.currentTarget).find("#SelectedGroups").val(),
                    FormAction: $(event.currentTarget).find("#FormAction").val()
                };

                // Fire event
                onFormSubmit_FormPeriod(vm);
            });

            $('#formUserScheduler_FormPeriod').kendoValidator(window.validation.getConfiguration());
        },

        /**
        * Init form shift for the button. Gets the information already filled (certain settings).
        */
        initFormShiftWork: function () {
            $("#SchedulePlanningButtonLoader").hide();

            $("#SchedulePlanningButton").click(function (e) {
                $("#SchedulePlanningButtonLoader").show();

                // Post Data
                $.ajax({
                    type: "POST",
                    url: appsettings.getUrl("UserScheduler/PlanShifts"),
                    data: {
                        ShiftWorkID: -1,
                        UserID: parseInt($("#SelectedUserId").val()),
                        AmountOfDays: $("#AmountOfDays").data("kendoNumericTextBox").value(),
                        ShiftType: parseInt($("#ShiftType").data("kendoDropDownList").value()),
                        StartDate: $("#StartDate").data("kendoDateTimePicker").value().toDateString(),
                        ShiftWorkDays: GetShiftWorkDaySettings($("#AmountOfDays").data("kendoNumericTextBox").value()),
                        SchedulerType: 1, // UserScheduler
                    },
                    success: function (responseData) {
                        if (responseData.Succesfully) {
                            $("#scheduler").data("kendoScheduler").dataSource.read();   // refresh scheduler

                            $("#SchedulePlanningButtonLoader").hide();
                            $('#ShiftWarning').text("")

                            //Close dialog
                            $("#PloegenScheduleWindow").data("kendoWindow").close();
                        } else {
                            $("#SchedulePlanningButtonLoader").hide();
                            $('#ShiftWarning').text(responseData.Message)
                        }
                    },

                    error: function () {
                        $("#SchedulePlanningButtonLoader").hide();
                    }
                });

            });

            // Form Submit ajax call
            $('#formUserScheduler_FormShift').submit(function (event) {
                // Prevent default
                event.preventDefault();

                // Make model to send.
                var vm = {}
                vm.preventDefault = event.preventDefault
                
                // Model
                vm.model = {
                    ShiftWorkID: parseInt($('#ShiftWorkID').val()),
                    AmountOfDays: parseInt($(event.currentTarget).find("#AmountOfDays").val()),
                    ShiftType: parseInt($(event.currentTarget).find("#ShiftType").val()),
                    StartDate: $(event.currentTarget).find("#StartDate").data("kendoDateTimePicker").value().toDateString(),
                    UserID: parseInt($(event.currentTarget).find("#UserID").val())
                };

                // Fire event
                onFormSubmit_FormShift(vm);
            });

            // Set validation config
            $('#formUserScheduler_FormShift').kendoValidator(window.validation.getConfiguration());
        },

        /**
        * Show or hide certain options when the type of edit has been changed.
        * @param {any} event
        */
        onChangeTypeOfEdit: function (e) {
            showHidePiketOptions();
        },

        /**
        * Submit formshift (custom and not handled by the taghelper because of the dynamic generated form and values presented in the form)
        * @param {any} e
        */
        scheduler_navigate: function (e) {
            if (e.view == 'day') {
                e.preventDefault();

                // Save selected date in hidden field for the dialog action to retrieve.
                $("#SelectedDate").val(e.date);

                // Presentation Dialog
                $("#dateFullDayNotAvailable").html(e.date.toLocaleDateString());
                $("#SelectedDate").val(e.date.toDateString());

                // Open dialog
                $("#DialogFullDayNotAvailable").data("kendoDialog").open();
            }
        },

        /**
        * Post Request set full day (whole day available)
        * @param {any} e
        */
        DialogFullDayAvailable: function (e) {
            _DialogFullDayAvailable(true);
        },

        /**
        * Post Request set full day (not available)
        * @param {any} e
        */
        DialogFullDayNotAvailable: function (e) {
            _DialogFullDayAvailable(false);
        },

        /**
        * Cancel
        * @param {any} e
        */
        DialogFullDayNotAvailable_onNo: function (e) {
            // Do nothing ...
        },

        /**
        * Selection drag drop mouse
        * @param {any} e
        */
        scheduler_onChange: function (e) {

            if (mouseDown == 1) {

                // captured by change event kendo scheduler (start selection)
                selectionChangeStart = e.start;

                // captured by change event kendo scheduler (end selection)
                selectionChangeEnd = e.end;
            }
        },

        scheduler_remove: function (e) {
            e.preventDefault();
            var now = new Date();

            if (e.event.end < now) {
                e.preventDefault();
            }
            else
            {
                if (e.event.start < now && e.event.end > now) {                    
                    e.event.start = now;
                }

                $.ajax({
                    type: "POST",
                    url: appsettings.getUrl("UserScheduler/SchedulerDestroy"),
                    data: {
                        selectedUserId: parseInt($("#SelectedUserId").val()),
                        appointmentTypeId: e.event.ColorID,
                        DBId: e.event.DBId,
                        startUTC: kendo.parseDate(e.event.start, "yyyy-MM-ddTHH:mm:sszzz").toUTCString(),
                        endUTC: kendo.parseDate(e.event.end, "yyyy-MM-ddTHH:mm:sszzz").toUTCString()                        
                    },
                    success: function (responseData) {
                        form.showResult(responseData);
                        $("#scheduler").data("kendoScheduler").dataSource.read();
                    }
                });
            }            
        },

        /**
        * Get additional information for the request scheduler
        */
        getAdditionalData: function () {

            var scheduler = $("#scheduler").data("kendoScheduler");
            var startDate = scheduler.view().startDate();
            var endDate = scheduler.view().endDate();

            var startTime = 0;
            var endTime = 0;

            if (scheduler.view().startTime) {
                //optionally add startTime / endTime of the view
                startTime = kendo.date.getMilliseconds(scheduler.view().startTime());
                endTime = kendo.date.getMilliseconds(scheduler.view().endTime());
                endTime = endTime == 0 ? kendo.date.MS_PER_DAY : endTime;
            }

            var result = {
                Start: new Date(startDate.getTime() - (startDate.getTimezoneOffset() * kendo.date.MS_PER_MINUTE) + startTime),
                End: new Date(endDate.getTime() - (endDate.getTimezoneOffset() * kendo.date.MS_PER_MINUTE) + endTime)
            }

            return result;
        },

        /**
        * Get additional information for the request scheduler
        * @param {any} e
        */
        getAdditionalDataUpdate: function (e) {
            for (var i = 0; i < tempData.length; i++) {
                if (e.UniqueIdentifier == tempData[i].UniqueIdentifier) {
                    $.ajax({
                        type: "POST",
                        url: appsettings.getUrl("UserScheduler/SchedulerUpdate"),
                        data: {
                            selectedUserId: parseInt($("#SelectedUserId").val()),                           
                            appointmentTypeId: tempData[i].appointmentTypeId,
                            dBId: tempData[i].dBId,
                            UTCstartOld: tempData[i].start.toUTCString(),
                            UTCendOld: tempData[i].end.toUTCString(),
                            UTCstartNew: kendo.parseDate(e.Start, "yyyy-MM-ddTHH:mm:sszzz").toUTCString(),
                            UTCendNew: kendo.parseDate(e.End, "yyyy-MM-ddTHH:mm:sszzz").toUTCString()
                        },
                        success: function (responseData) {
                            form.showResult(responseData);
                            $("#scheduler").data("kendoScheduler").dataSource.read();
                        }
                    });
                }
            }
        },

        /**
        * Get the data from the scheduler when data is loaded into the tempData array. 
        * @param {any} e
        */
        scheduler_dataBound: function (e) {
            var data = $("#scheduler").data("kendoScheduler").data();
            tempData = new Array();

            // copy to a new array
            for (var i = 0; i < data.length; i++) {
                tempData.push({
                    UniqueIdentifier: data[i].UniqueIdentifier,
                    dBId: data[i].DBId,
                    start: data[i].start,
                    end: data[i].end,
                    appointmentTypeId: data[i].ColorID
                });
            }
        },

        /**
        * Post request for set Full week
        * @param {any} e
        */
        DialogSetSelectedWeekNotAvailable_onYes: function (e) {
            // get the scheduler
            var scheduler = $("#scheduler").data("kendoScheduler");

            // start and stop full week
            var start = scheduler.view().startDate();
            var stop = scheduler.view().endDate();
            stop.setDate(stop.getDate() + 1);

            // get current datetime
            var current_datetime = new Date();

            // check
            if (current_datetime > start) {
                start = current_datetime;
            }

            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("UserScheduler/SetFullWeek"),
                data: {
                    UserId: parseInt($("#SelectedUserId").val()),
                    BeginDay: start.toDateString(),
                    EndDay: stop.toDateString()
                },
                success: function (responseData) {
                    form.showResult(responseData);
                    $("#scheduler").data("kendoScheduler").dataSource.read();
                }
            });
        },

        /**
        * Cancel action -> Post request for set Full week
        * @param {any} e
        */
        DialogSetSelectedWeekNotAvailable_onNo: function (e) {
            // Do nothing...
        },

        /**
        * Start date. This will change the enddate to a certain date that is logical.
        */
        startChange: function () {
            var endPicker = $("#ToDate").data("kendoDatePicker"),
                startDate = this.value();

            if (startDate) {
                startDate = new Date(startDate);
                startDate.setDate(startDate.getDate() + 1);
                endPicker.min(startDate);
            }
        },

        /**
        * End date. This will change the startdate to a certain date that is logical.
        */
        endChange: function () {
            var startPicker = $("#FromDate").data("kendoDatePicker"),
                endDate = this.value();

            if (endDate) {
                endDate = new Date(endDate);
                endDate.setDate(endDate.getDate() - 1);
                startPicker.max(endDate);
            }
        },

        /**
        * Initiate / open form shift.
        */
        onFormInitiate_FormShift: function () {
            // Do nothing...
        },

        selectedGroupsAssigned_Changed: function () {
            // $('#SelectedGroups')[0].value = ['1', '2'];
            var cbl = $('#SelectedGroups').data("kendoCheckBoxGroup"); 

            if (cbl != null) {
                var newValue = [];

                for (var i = 0; i < cbl.items().length; i++) {
                    if (cbl.items()[i].checked) {
                        newValue.push(cbl.items()[i].value);
                    }
                }

                $('#SelectedGroups')[0].value = newValue;
            }
        }
    }
}();